import { getWarehouseValuesSummaryToday } from "src/utils/apiRequests";
import { useResponseLegacy } from "../useResponse";


export const useGetWarehouseValuesSummary = () => {
    const [response] = useResponseLegacy<any[]>(getWarehouseValuesSummaryToday);
    return response;
}
